//react
import React from "react";
import { useHistory } from "react-router-dom";
import Highlighter from "react-highlight-words";

//UI
import { Table, Empty, Popover, Button, Space } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import LoadingComponent from "../../Common/LoadingComponent";
import {
  ColoredTextTag,
  TEXT_TAG_COLORS,
} from "../../Common/ColoredTextTag/ColoredTextTag";

//processing
import { tableStringSorter } from "../../../utils/table";
import { ONBOARDING_CUSTOMER_STATUS } from "../../../utils/onboarding-helper";

//css
import "./styles.css";

// set table height according to window
let tableHeight = 400;
if (window.innerWidth > 700) {
  tableHeight = window.innerHeight - 375;
}

// const deactivateCustomer = (props) => {
//   alert("deactivateCustomer " + props);
// };

const textColor = (status) => {
  switch (status) {
    case ONBOARDING_CUSTOMER_STATUS.CUSTOMER_CREATED:
      return <ColoredTextTag text={status} color={TEXT_TAG_COLORS.SUCCESS} />;
    case ONBOARDING_CUSTOMER_STATUS.PENDING:
      return <ColoredTextTag text={status} color={TEXT_TAG_COLORS.WARN} />;
    default:
      return <ColoredTextTag text={status} color="black" />;
  }
};

const OnboardingHomePageTable = (props) => {
  const { searchedColumns, customerData, searchedWords, isLoadingCustomers } =
    props;
  const history = useHistory();
  const OptionsContent = (id, status) => {
    return (
      <Space direction="vertical" size={0}>
        <Button
          className="option-button"
          onClick={() => {
            history.push(`/onboarding/properties?customer=${id}`);
          }}
        >
          View Property(s)
        </Button>
        <Button
          className="option-button"
          onClick={() => {
            history.push(`/onboarding/users?customer=${id}`);
          }}
        >
          Manage User(s)
        </Button>
        <Button
          className="option-button"
          onClick={() => {
            history.push(`/onboarding/customer/edit?customer=${id}`);
          }}
          disabled={status !== ONBOARDING_CUSTOMER_STATUS.IN_DRAFT}
        >
          Edit Customer
        </Button>
        <Button
          className="option-button"
          onClick={() => {
            // deactivateCustomer(props);
          }}
          disabled
        >
          Deactivate Customer
        </Button>
      </Space>
    );
  };

  // render component for hilightable search text
  const searchHighlighter = (dataIndex) => ({
    render: (text) => {
      return searchedColumns.includes(dataIndex) ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={searchedWords}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      );
    },
  });

  // table columns
  const columns = [
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
      width: "200px",
      sorter: tableStringSorter("customer_name"),
      fixed: "left",
      ...searchHighlighter("customer_name"),
    },
    {
      title: "Customer Address",
      dataIndex: "address",
      key: "address",
      width: "200px",
      sorter: tableStringSorter("address"),
      ...searchHighlighter("address"),
    },
    {
      title: "Project Overview",
      dataIndex: "project_overview",
      key: "project_overview",
      width: "200px",
      sorter: tableStringSorter("project_overview"),
      ...searchHighlighter("project_overview"),
    },
    {
      title: "Contract Date",
      dataIndex: "contract_date",
      key: "contract_date",
      width: "200px",
      sorter: tableStringSorter("contract_date"),
      ...searchHighlighter("contract_date"),
    },
    {
      title: "Effective Date",
      dataIndex: "effective_date",
      key: "effective_date",
      width: "200px",
      sorter: tableStringSorter("effective_date"),
      ...searchHighlighter("effective_date"),
    },
    {
      title: "Solution",
      dataIndex: "solution",
      key: "solution",
      width: "200px",
      sorter: tableStringSorter("solution"),
      ...searchHighlighter("solution"),
    },
    {
      title: "Corporate Contact First Name",
      dataIndex: "corporate_contact_first_name",
      key: "corporate_contact_first_name",
      width: "200px",
      sorter: tableStringSorter("corporate_contact_first_name"),
      ...searchHighlighter("corporate_contact_first_name"),
    },
    {
      title: "Corporate Contact Last Name",
      dataIndex: "corporate_contact_last_name",
      key: "corporate_contact_last_name",
      width: "200px",
      sorter: tableStringSorter("corporate_contact_last_name"),
      ...searchHighlighter("corporate_contact_last_name"),
    },
    {
      title: "Corporate Contact Email",
      dataIndex: "corporate_contact_email",
      key: "corporate_contact_email",
      width: "200px",
      sorter: tableStringSorter("corporate_contact_email"),
      ...searchHighlighter("corporate_contact_email"),
    },
    {
      title: "Billing Address",
      dataIndex: "billing_address",
      key: "billing_address",
      width: "200px",
      sorter: tableStringSorter("billing_address"),
      ...searchHighlighter("billing_address"),
    },
    {
      title: "Billing Contact",
      dataIndex: "billing_contact_name",
      key: "billing_contact_name",
      width: "200px",
      sorter: tableStringSorter("billing_contact_name"),
      ...searchHighlighter("billing_contact_name"),
    },
    {
      title: "Billing Phone Number",
      dataIndex: "billing_phone_number",
      key: "billing_phone_number",
      width: "200px",
      sorter: tableStringSorter("billing_phone_number"),
      ...searchHighlighter("billing_phone_number"),
    },
    {
      title: "Billing Method",
      dataIndex: "billing_method",
      key: "billing_method",
      width: "200px",
      sorter: tableStringSorter("billing_method"),
      ...searchHighlighter("billing_method"),
    },
    {
      title: "Billing Timeline",
      dataIndex: "billing_timeline",
      key: "billing_timeline",
      width: "200px",
      sorter: tableStringSorter("billing_timeline"),
      ...searchHighlighter("billing_timeline"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "150px",
      sorter: tableStringSorter("status"),
      ...searchHighlighter("status"),
      render: (idx, record) => textColor(record?.status),

      fixed: "right",
    },
    {
      title: "   ",
      key: "options",
      dataIndex: "_id",
      width: "50px",
      render: (_id, record) => {
        return (
          <span className="more-options-container">
            <Popover
              content={OptionsContent(_id, record.status)}
              placement="left"
              trigger="click"
              overlayClassName="more-options"
            >
              <MoreOutlined />
            </Popover>
          </span>
        );
      },
      fixed: "right",
    },
  ];

  return (
    <div>
      {!Array.isArray(customerData) || customerData.length === 0 ? (
        <Empty description="No Customer found" />
      ) : (
        <Table
          className="onboarding-customer-table"
          columns={columns}
          dataSource={customerData ?? []}
          rowKey="_id"
          scroll={{ x: 1100, y: tableHeight }}
          pagination={{
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "25", "50", "100"],
          }}
          locale={{
            emptyText: isLoadingCustomers ? (
              <div className="spinner-table">
                <LoadingComponent />
              </div>
            ) : null,
          }}
        />
      )}
    </div>
  );
};

export default OnboardingHomePageTable;
